import React from 'react';

import { Button as AntdButton } from 'antd';

import { BrancheDto } from 'lib_api/lib/api/gen';

import { useModal } from 'hooks/modal/useModal';

import ModalDetails from './Modals/ModalDetails';
import ModalModification from './Modals/ModalModification';

interface CellDetailsAndActionsProps {
  branche: BrancheDto;
  refreshDashboard: () => void;
}

function CellDetailsAndActions({
  branche,
  refreshDashboard,
}: CellDetailsAndActionsProps): React.ReactElement {
  const modalDetails = useModal();
  const modalModification = useModal();

  return (
    <>
      <AntdButton onClick={modalDetails.open}>Détails</AntdButton>
      <ModalDetails
        branche={branche}
        visible={modalDetails.visible}
        close={modalDetails.close}
      />
      <AntdButton className="menuActions" onClick={modalModification.open}>
        Modifier
      </AntdButton>
      <ModalModification
        refreshDashboard={refreshDashboard}
        branche={branche}
        visible={modalModification.visible}
        close={modalModification.close}
      />
    </>
  );
}

export default CellDetailsAndActions;
